(function () {
  var SABERS = {
    light: ["Silver Scavenger","Paragon","Vega","Revenant","Paladin","Legacy","Heirloom","Zeta","Insurgent","Enlightened","Wisdom","Pathfinder"],
    dark: ["Black Scavenger","Nova","Retribution","Dauntless","Eclipse","Knight","Sentinel","Incursion","Arc","Polaris"],
    balanced: ["Excalibur","Atlas","Athena","Resistance","Divergent","Regent","Aether","Highcrest"]
  };

  var ALIGNMENT_TEXT = {
    light: "You fight with honor, discipline, and purpose. The light side guides your blade.",
    dark: "You embrace power, aggression, and control. The dark side fuels your strength.",
    balanced: "You walk the line between chaos and order. Your strength lies in balance."
  };

  var PROMPTS = [
    { q: "A frightened village asks for aid while your own mission hangs in the balance. What do you do?", a: [{ t: "Protect the village first, no matter the delay.", v: "light" }, { t: "Stay on mission. Weakness can wait.", v: "dark" }, { t: "Secure the mission while minimizing harm to both.", v: "balanced" }]},
    { q: "A rival insults you before a crowd of allies. Your response?", a: [{ t: "Remain composed and let discipline speak for you.", v: "light" }, { t: "Break their pride immediately and publicly.", v: "dark" }, { t: "Turn the moment to your advantage with calm pressure.", v: "balanced" }]},
    { q: "You discover forbidden knowledge hidden in a ruined archive.", a: [{ t: "Seal it away if it threatens others.", v: "light" }, { t: "Take it. Power belongs to the bold.", v: "dark" }, { t: "Study it carefully and decide later.", v: "balanced" }]},
    { q: "A teammate fails and puts everyone at risk.", a: [{ t: "Lift them up and help them recover.", v: "light" }, { t: "Remove them before they fail again.", v: "dark" }, { t: "Keep them close, but under your watch.", v: "balanced" }]},
    { q: "An enemy surrenders after a brutal duel.", a: [{ t: "Accept surrender and show mercy.", v: "light" }, { t: "Finish it. Mercy invites betrayal.", v: "dark" }, { t: "Spare them if it serves a larger purpose.", v: "balanced" }]},
    { q: "You are offered command over a powerful order.", a: [{ t: "Lead to protect and serve others.", v: "light" }, { t: "Lead so no one can challenge you.", v: "dark" }, { t: "Lead only if it grants freedom to act your way.", v: "balanced" }]},
    { q: "A mysterious force calls you into the unknown.", a: [{ t: "Follow it with faith and restraint.", v: "light" }, { t: "Seize it before anyone else can.", v: "dark" }, { t: "Test it first and trust your own judgment.", v: "balanced" }]},
    { q: "During battle, rules prevent the fastest victory.", a: [{ t: "Hold to the code. Victory without honor is hollow.", v: "light" }, { t: "Discard the rules and win at any cost.", v: "dark" }, { t: "Bend the rules only as far as needed.", v: "balanced" }]},
    { q: "You find an ancient saber with a dangerous past.", a: [{ t: "Preserve it carefully and learn its history.", v: "light" }, { t: "Claim it. Dark legends only make it stronger.", v: "dark" }, { t: "Use it if it proves worthy in your hands.", v: "balanced" }]},
    { q: "Your closest ally hides the truth from you.", a: [{ t: "Seek understanding before judgment.", v: "light" }, { t: "Make them regret the deception.", v: "dark" }, { t: "Use the truth when it becomes useful.", v: "balanced" }]},
    { q: "You stand before a defeated tyrant's throne.", a: [{ t: "Destroy it and free the people.", v: "light" }, { t: "Take the throne and rule harder.", v: "dark" }, { t: "Use the throne until it no longer serves you.", v: "balanced" }]},
    { q: "A master tells you to be patient when you crave action.", a: [{ t: "Patience is part of strength.", v: "light" }, { t: "Waiting is for the weak.", v: "dark" }, { t: "Wait only if it creates an advantage.", v: "balanced" }]},
    { q: "You can save one priceless relic or one stranger.", a: [{ t: "Save the stranger without hesitation.", v: "light" }, { t: "Take the relic. Power changes everything.", v: "dark" }, { t: "Judge which one shifts the future more.", v: "balanced" }]},
    { q: "The path ahead splits into safety, conquest, and uncertainty.", a: [{ t: "Choose the path that protects the most people.", v: "light" }, { t: "Choose conquest. Fear clears the way.", v: "dark" }, { t: "Choose uncertainty. Freedom lies there.", v: "balanced" }]},
    { q: "A duel is moments away. How do you center yourself?", a: [{ t: "Breathe, focus, and let discipline guide you.", v: "light" }, { t: "Feed the fire and strike with overwhelming force.", v: "dark" }, { t: "Read the field and adapt before the first move.", v: "balanced" }]}
  ];

  var quizState = { prompts: [], index: 0, answers: [] };

  function shuffle(arr) {
    var copy = arr.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i]; copy[i] = copy[j]; copy[j] = temp;
    }
    return copy;
  }

  function saberHandle(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function selectQuizPromptSet() {
    quizState.prompts = shuffle(PROMPTS).slice(0, 15);
    quizState.index = 0;
    quizState.answers = new Array(15);
  }

  function renderQuiz() {
    var questionEl = document.getElementById('quizQuestion');
    var answersEl = document.getElementById('quizAnswers');
    var currentStepEl = document.getElementById('quizCurrentStep');
    var progressFillEl = document.getElementById('quizProgressFill');
    var backEl = document.getElementById('quizBack');
    var nextEl = document.getElementById('quizNext');
    if (!questionEl || !answersEl || !currentStepEl || !progressFillEl || !backEl || !nextEl || !quizState.prompts.length) return;

    var prompt = quizState.prompts[quizState.index];
    questionEl.textContent = prompt.q;
    currentStepEl.textContent = String(quizState.index + 1);
    progressFillEl.style.width = (((quizState.index + 1) / 15) * 100) + '%';
    backEl.disabled = quizState.index === 0;
    nextEl.textContent = quizState.index === 14 ? 'Reveal My Saber' : 'Next';

    var saved = quizState.answers[quizState.index];
    var html = '';
    for (var i = 0; i < prompt.a.length; i++) {
      var isActive = saved === prompt.a[i].v ? ' is-active' : '';
      html += '<button type="button" class="quiz-option quiz-cycle-option' + isActive + '" data-quiz-value="' + prompt.a[i].v + '">' + prompt.a[i].t + '</button>';
    }
    answersEl.innerHTML = html;
  }

  function computeResult() {
    var score = { light: 0, dark: 0, balanced: 0 };
    for (var i = 0; i < quizState.answers.length; i++) {
      var val = quizState.answers[i];
      if (score.hasOwnProperty(val)) score[val] += 1;
    }
    var alignment = 'light';
    if (score.dark > score.light && score.dark >= score.balanced) alignment = 'dark';
    else if (score.balanced > score.light && score.balanced >= score.dark) alignment = 'balanced';

    var pool = SABERS[alignment];
    var pick = pool[Math.floor(Math.random() * pool.length)];

    var titleEl = document.getElementById('quizTitle');
    var textEl = document.getElementById('quizText');
    var linkEl = document.getElementById('quizLink');
    var tagsEl = document.getElementById('quizEmailTags');
    var noteEl = document.getElementById('quizEmailNote');

    if (titleEl) titleEl.textContent = pick;
    if (textEl) textEl.textContent = ALIGNMENT_TEXT[alignment];
    if (linkEl) linkEl.href = '/products/' + saberHandle(pick);
    if (tagsEl) tagsEl.value = 'Quiz Lead, ' + alignment + ', ' + pick;
    if (noteEl) noteEl.value = 'Quiz Result: ' + pick + ' (' + alignment + ')';
  }

  function seedParts(section, labels, specFn) {
    var out = [];
    for (var i = 0; i < labels.length; i++) {
      var base = specFn(i) || {};
      base.id = section + '-' + i;
      base.label = labels[i];
      base.tags = base.tags || [section];
      out.push(base);
    }
    return out;
  }

  var BUILDER_DATA = {
    emitter: seedParts('emitter', ['Fang','Halo','Relic','Crown','Vane','Forge','Prism','Citadel','Rift','Vortex','Shard','Vector'], function(i){
      return { length: 78 + (i % 4) * 4, radius: 33 + (i % 3), taper: [0.84,0.76,0.90,0.80][i % 4], rings: [0.16,0.38,0.66].slice(0, 2 + (i % 2)), grooves: i % 2 ? [0.30,0.58] : [0.34], windows: [0,1,2][i % 3], box: false, emitterCut: [0,1,2,3][i % 4], gripSlots: 0, pommelVents: 0, controlBox: 0, tags: ['combat', i % 2 ? 'aggressive' : 'clean'] };
    }),
    switch: seedParts('switch', ['Vault','Relay','Monarch','Citadel','Bridge','Haven','Sentinel','Axis','Signal','Aegis','Prime','Core'], function(i){
      return { length: 66 + (i % 4) * 4, radius: 30 + (i % 3), taper: 1, rings: [0.18,0.78], grooves: i % 2 ? [0.32,0.56] : [0.42], windows: [0,1,2][i % 3], box: true, controlBox: [1,2,3][i % 3], gripSlots: 0, pommelVents: 0, emitterCut: 0, tags: ['control', i % 2 ? 'boxed' : 'clean'] };
    }),
    handle: seedParts('handle', ['Ribbed','Tactical','Vaulted','Ornate','Carbon','Cinder','Runic','Strata','Vector','Ranger','Bastion','Obsidian'], function(i){
      return { length: 160 + (i % 5) * 6, radius: 28 + (i % 4), taper: 1, rings: [0.12,0.26,0.40,0.54,0.68,0.82].slice(0, 3 + (i % 4)), grooves: i % 2 ? [0.18,0.32,0.46,0.60,0.74] : [0.34,0.66], windows: [0,0,2,3][i % 4], box: false, gripSlots: [0,2,3,4][i % 4], pommelVents: 0, controlBox: 0, emitterCut: 0, tags: ['grip', i % 2 ? 'detailed' : 'clean'] };
    }),
    pommel: seedParts('pommel', ['Vented','Forge','Crowned','Capped','Hilt-End','Obelisk','Relic-End','Bastion-End','Echo','Vault-End','Nova-End','Cinder-End'], function(i){
      return { length: 60 + (i % 4) * 4, radius: 32 + (i % 3), taper: [1.06,1.12,1.18,1.10][i % 4], rings: [0.16,0.42,0.80].slice(0, 2 + (i % 2)), grooves: [0.34,0.58].slice(0, 1 + (i % 2)), windows: [0,1,0,1][i % 4], box: false, pommelVents: [1,2,4,6][i % 4], emitterCut: 0, gripSlots: 0, controlBox: 0, tags: ['endcap', i % 2 ? 'vented' : 'clean'] };
    })
  };

  var builderState = {
    emitter: BUILDER_DATA.emitter[0].id,
    switch: BUILDER_DATA.switch[0].id,
    handle: BUILDER_DATA.handle[0].id,
    pommel: BUILDER_DATA.pommel[0].id,
    activeSection: 'emitter',
    search: '',
    finish: 'steel',
    chamber: 'none'
  };

  function finishClass() { return 'finish-' + builderState.finish; }

  function currentConfig() {
    return {
      emitter: getPart('emitter', builderState.emitter).label,
      switch: getPart('switch', builderState.switch).label,
      handle: getPart('handle', builderState.handle).label,
      pommel: getPart('pommel', builderState.pommel).label,
      finish: builderState.finish,
      crystal_chamber: builderState.chamber
    };
  }

  function syncBuilderConfigFields() {
    var field = document.getElementById('builderConfigField');
    if (field) field.value = JSON.stringify(currentConfig());
  }

  function buildFaces(radius, length, taper, facets) {
    var html = '';
    var faceWidth = Math.max(8, Math.round((2 * Math.PI * radius) / facets * 1.02));
    for (var i = 0; i < facets; i++) {
      var rot = (360 / facets) * i;
      html += '<span class="prism-face ' + finishClass() + '" style="width:' + faceWidth + 'px;height:' + length + 'px;transform:translateX(-50%) rotateY(' + rot + 'deg) translateZ(' + radius + 'px) scaleX(' + taper + ');"></span>';
    }
    html += '<span class="prism-cap cap-top ' + finishClass() + '" style="width:' + (radius*2.06) + 'px;height:' + (radius*2.06) + 'px;"></span>';
    html += '<span class="prism-cap cap-bottom ' + finishClass() + '" style="width:' + (radius*2.06) + 'px;height:' + (radius*2.06) + 'px;transform:translateX(-50%) translateY(' + (length - radius*2.06) + 'px) rotateX(90deg);"></span>';
    return html;
  }

  function getPart(group, id) {
    var items = BUILDER_DATA[group] || [];
    for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i];
    return items[0];
  }

  function addDecor(part, totalLength) {
    var html = '';
    var radius = part.radius;
    if (part.rings) for (var i = 0; i < part.rings.length; i++) html += '<span class="builder-ring ' + finishClass() + '" style="top:' + Math.round(part.rings[i] * totalLength) + 'px;width:' + (radius*2.42) + 'px;height:9px;"></span>';
    if (part.grooves) for (var j = 0; j < part.grooves.length; j++) html += '<span class="builder-groove" style="top:' + Math.round(part.grooves[j] * totalLength) + 'px;width:' + (radius*2.10) + 'px;height:4px;"></span>';
    if (part.windows) for (var k = 0; k < part.windows; k++) html += '<span class="builder-window" style="top:' + (Math.round(totalLength * 0.18) + k * 22) + 'px;width:' + (radius*0.70) + 'px;height:15px;"></span>';
    if (part.controlBox) for (var b = 0; b < part.controlBox; b++) html += '<span class="builder-box ' + finishClass() + '" style="top:' + Math.round(totalLength*(0.22 + b*0.16)) + 'px;width:' + (b === 0 ? radius*0.80 : radius*0.54) + 'px;height:' + (b === 0 ? 24 : 16) + 'px;"></span>';
    if (part.gripSlots) for (var s = 0; s < part.gripSlots; s++) html += '<span class="builder-slot" style="top:' + Math.round(totalLength*(0.14 + s*0.16)) + 'px;width:' + (radius*0.24) + 'px;height:' + Math.round(totalLength*0.12) + 'px;transform:translateX(-50%) rotateY(' + (s*90) + 'deg) translateZ(' + (radius+1) + 'px);"></span>';
    if (part.emitterCut) for (var e = 0; e < part.emitterCut; e++) html += '<span class="builder-emitter-cut" style="top:' + Math.round(totalLength*0.04 + e*10) + 'px;width:' + (radius*0.44) + 'px;height:' + Math.round(totalLength*0.16) + 'px;transform:translateX(-50%) rotateY(' + (e*(360/part.emitterCut)) + 'deg) translateZ(' + (radius+2) + 'px);"></span>';
    if (part.pommelVents) for (var v = 0; v < part.pommelVents; v++) html += '<span class="builder-vent" style="top:' + Math.round(totalLength*0.42) + 'px;width:' + Math.max(8, radius*0.22) + 'px;height:' + Math.round(totalLength*0.18) + 'px;transform:translateX(-50%) rotateY(' + ((360 / part.pommelVents) * v) + 'deg) translateZ(' + (radius + 1) + 'px);"></span>';
    return html;
  }

  function renderBuilderModel() {
    var model = document.getElementById('builderModel');
    var modelRef = document.getElementById('builderModelReflection');
    if (!model) return;
    var order = ['emitter','switch','handle','pommel'];
    var top = 0;
    var html = '';

    for (var i = 0; i < order.length; i++) {
      var group = order[i];
      var part = getPart(group, builderState[group]);
      html += '<div class="builder-segment group-' + group + '" style="top:' + top + 'px;height:' + part.length + 'px;width:' + (part.radius*3.8) + 'px;">';
      html += buildFaces(part.radius, part.length, part.taper || 1, 44);
      html += addDecor(part, part.length);
      html += '</div>';

      if (builderState.chamber === 'upper' && group === 'emitter') {
        var chamberTop = top + part.length - 2;
        html += renderCrystalChamber(chamberTop, 'upper');
        top += 68;
      }

      if (builderState.chamber === 'lower' && group === 'handle') {
        var chamberLowerTop = top + part.length - 2;
        html += renderCrystalChamber(chamberLowerTop, 'lower');
        top += 68;
      }

      top += part.length - 4;
    }
    model.innerHTML = html;
    if (modelRef) modelRef.innerHTML = html;
    syncBuilderConfigFields();
  }


  function renderCrystalChamber(top, placement) {
    var radius = 29;
    var html = '';
    html += '<div class="builder-segment group-chamber chamber-' + placement + '" style="top:' + top + 'px;height:70px;width:' + (radius*4.2) + 'px;">';
    html += buildFaces(radius, 70, 1, 36);
    html += '<span class="builder-chamber-rail left ' + finishClass() + '" style="top:8px;height:54px;transform:translateX(-50%) rotateY(0deg) translateZ(' + (radius + 6) + 'px);"></span>';
    html += '<span class="builder-chamber-rail right ' + finishClass() + '" style="top:8px;height:54px;transform:translateX(-50%) rotateY(180deg) translateZ(' + (radius + 6) + 'px);"></span>';
    html += '<span class="builder-chamber-core" style="top:14px;height:42px;"></span>';
    html += '<span class="builder-chamber-ring ' + finishClass() + '" style="top:8px;"></span>';
    html += '<span class="builder-chamber-ring ' + finishClass() + '" style="top:54px;"></span>';
    html += '</div>';
    return html;
  }

  function renderSelectionBar() {
    var root = document.getElementById('builderSelectionBar');
    if (!root) return;
    var groups = ['emitter','switch','handle','pommel'];
    var html = '';
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var part = getPart(group, builderState[group]);
      var title = group === 'switch' ? 'Button Section' : group.charAt(0).toUpperCase() + group.slice(1);
      html += '<button type="button" class="builder-pill' + (builderState.activeSection === group ? ' is-active' : '') + '" data-builder-tab="' + group + '"><span class="builder-pill-title">' + title + '</span><span class="builder-pill-value">' + part.label + '</span></button>';
    }
    root.innerHTML = html;
  }

  function renderSectionTabs() {
    var root = document.getElementById('builderSectionTabs');
    if (!root) return;
    var groups = ['emitter','switch','handle','pommel'];
    var html = '';
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var label = group === 'switch' ? 'Button Section' : group.charAt(0).toUpperCase() + group.slice(1);
      html += '<button type="button" class="builder-section-tab' + (builderState.activeSection === group ? ' is-active' : '') + '" data-builder-tab="' + group + '">' + label + '</button>';
    }
    root.innerHTML = html;
  }

  function renderBuilderLibrary() {
    var grid = document.getElementById('builderLibraryGrid');
    var meta = document.getElementById('builderLibraryMeta');
    if (!grid) return;
    var items = BUILDER_DATA[builderState.activeSection] || [];
    var q = (builderState.search || '').toLowerCase().trim();
    var filtered = items.filter(function (item) {
      if (!q) return true;
      var blob = [item.label].concat(item.tags || []).join(' ').toLowerCase();
      return blob.indexOf(q) !== -1;
    });
    var html = '';
    for (var i = 0; i < filtered.length; i++) {
      var item = filtered[i];
      var active = builderState[builderState.activeSection] === item.id ? ' is-active' : '';
      html += '<button type="button" class="builder-library-card' + active + '" data-builder-group="' + builderState.activeSection + '" data-builder-part="' + item.id + '">';
      html += '<span class="builder-library-preview ' + finishClass() + '"><span class="builder-library-preview-inner"></span></span>';
      html += '<span class="builder-library-card-title">' + item.label + '</span>';
      html += '<span class="builder-library-card-meta">' + (item.tags || []).slice(0,2).join(' · ') + '</span>';
      html += '</button>';
    }
    grid.innerHTML = html;
    if (meta) meta.textContent = filtered.length + ' parts in ' + (builderState.activeSection === 'switch' ? 'Button Section' : builderState.activeSection);
  }

  function renderBuilderUI() {
    renderSelectionBar();
    renderSectionTabs();
    renderBuilderLibrary();
    renderBuilderModel();
  }

  function initBuilderSystem() {
    if (!document.getElementById('builderModel')) return;
    renderBuilderUI();
  }

  function setBuilderView(rx, ry) {
    var builder = document.getElementById('IWBuilder');
    if (!builder) return;
    builder.setAttribute('data-rx', rx);
    builder.setAttribute('data-ry', ry);
    builder.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
  }

  function initBuilderDrag() {
    var stage = document.getElementById('IWBuilderStage');
    var builder = document.getElementById('IWBuilder');
    if (!stage || !builder) return;
    var dragging = false, startX = 0, startY = 0, startRX = 0, startRY = 0;
    setBuilderView(-14, -28);

    function begin(x, y) {
      dragging = true; startX = x; startY = y;
      startRX = parseFloat(builder.getAttribute('data-rx') || '-14');
      startRY = parseFloat(builder.getAttribute('data-ry') || '-28');
      stage.classList.add('is-dragging');
    }
    function move(x, y) {
      if (!dragging) return;
      var dx = x - startX, dy = y - startY;
      setBuilderView(Math.max(-74, Math.min(74, startRX - dy * 0.30)), startRY + dx * 0.64);
    }
    function end() { dragging = false; stage.classList.remove('is-dragging'); }

    stage.addEventListener('mousedown', function (e) { begin(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', end);
    stage.addEventListener('touchstart', function (e) { if (e.touches[0]) begin(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    window.addEventListener('touchmove', function (e) { if (e.touches[0]) move(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    window.addEventListener('touchend', end);
  }

  function initBuilderSearch() {
    var input = document.getElementById('builderSearchInput');
    if (!input) return;
    input.addEventListener('input', function () {
      builderState.search = input.value || '';
      renderBuilderLibrary();
    });
  }

  function initBuilderCart() {
    var btn = document.getElementById('builderAddToCart');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var config = currentConfig();
      var formData = new FormData();
      formData.append('id', '1');
      formData.append('quantity', '1');
      formData.append('properties[Emitter]', config.emitter);
      formData.append('properties[Button Section]', config.switch);
      formData.append('properties[Handle]', config.handle);
      formData.append('properties[Pommel]', config.pommel);
      formData.append('properties[Finish]', config.finish);
      formData.append('properties[Crystal Chamber]', config.crystal_chamber);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(function () {
        btn.textContent = 'Added To Cart';
        setTimeout(function(){ btn.textContent = 'Add Build To Cart'; }, 2000);
      }).catch(function () {
        btn.textContent = 'Cart Error';
        setTimeout(function(){ btn.textContent = 'Add Build To Cart'; }, 2000);
      });
    });
  }

  

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-builder-tab]');
    if (tab) {
      builderState.activeSection = tab.getAttribute('data-builder-tab');
      renderBuilderUI();
      return;
    }

    var libraryCard = event.target.closest('.builder-library-card');
    if (libraryCard) {
      var group = libraryCard.getAttribute('data-builder-group');
      var part = libraryCard.getAttribute('data-builder-part');
      if (group && part) {
        builderState[group] = part;
        renderBuilderUI();
      }
      return;
    }

    var finishBtn = event.target.closest('.builder-finish');
    if (finishBtn) {
      var finish = finishBtn.getAttribute('data-finish');
      if (finish) {
        builderState.finish = finish;
        var btns = document.querySelectorAll('.builder-finish');
        for (var i0 = 0; i0 < btns.length; i0++) btns[i0].classList.remove('is-active');
        finishBtn.classList.add('is-active');
        renderBuilderUI();
      }
      return;
    }

    var chamberBtn = event.target.closest('.builder-chamber');
    if (chamberBtn) {
      var chamber = chamberBtn.getAttribute('data-chamber');
      if (chamber) {
        builderState.chamber = chamber;
        var cbtns = document.querySelectorAll('.builder-chamber');
        for (var ic = 0; ic < cbtns.length; ic++) cbtns[ic].classList.remove('is-active');
        chamberBtn.classList.add('is-active');
        renderBuilderUI();
      }
      return;
    }

    var bladeBtn = event.target.closest('.builder-option');
    if (bladeBtn && bladeBtn.getAttribute('data-target') === 'builderBlade') {
      var wrap = bladeBtn.closest('.builder-options');
      if (wrap) {
        var btns = wrap.querySelectorAll('.builder-option');
        for (var i2 = 0; i2 < btns.length; i2++) btns[i2].classList.remove('is-active');
      }
      bladeBtn.classList.add('is-active');
      var target = document.getElementById('builderBlade');
      var targetRef = document.getElementById('builderBladeReflection');
      var blade = bladeBtn.getAttribute('data-blade');
      if (target && blade) target.className = target.className.replace(/blade-blue|blade-red|blade-green|blade-purple/g, '').replace(/\s+/g, ' ').trim() + ' blade-' + blade;
      if (targetRef && blade) targetRef.className = targetRef.className.replace(/blade-blue|blade-red|blade-green|blade-purple/g, '').replace(/\s+/g, ' ').trim() + ' blade-' + blade;
      return;
    }

    var cycleOption = event.target.closest('.quiz-cycle-option');
    if (cycleOption) {
      var optionsWrap = cycleOption.parentNode;
      if (optionsWrap) {
        var opts = optionsWrap.querySelectorAll('.quiz-cycle-option');
        for (var j = 0; j < opts.length; j++) opts[j].classList.remove('is-active');
      }
      cycleOption.classList.add('is-active');
      quizState.answers[quizState.index] = cycleOption.getAttribute('data-quiz-value');
      return;
    }

    var backBtn = event.target.closest('#quizBack');
    if (backBtn) { if (quizState.index > 0) { quizState.index -= 1; renderQuiz(); } return; }
    var nextBtn = event.target.closest('#quizNext');
    if (nextBtn) {
      if (!quizState.answers[quizState.index]) {
        var first = document.querySelector('#quizAnswers .quiz-cycle-option');
        if (first) { first.classList.add('is-active'); quizState.answers[quizState.index] = first.getAttribute('data-quiz-value'); }
      }
      if (quizState.index < 14) { quizState.index += 1; renderQuiz(); } else { computeResult(); }
      return;
    }
    var retakeBtn = event.target.closest('#quizRetake');
    if (retakeBtn) { selectQuizPromptSet(); renderQuiz(); var note = document.getElementById('quizShareNote'); if (note) note.textContent = ''; return; }
    var shareBtn = event.target.closest('#quizShare');
    if (shareBtn) {
      var titleEl = document.getElementById('quizTitle');
      var noteEl = document.getElementById('quizShareNote');
      var resultTitle = titleEl ? titleEl.textContent : 'my Imperial Workshop saber';
      var shareText = 'I got matched with ' + resultTitle + ' on the Imperial Workshop quiz.';
      if (navigator.share) navigator.share({ title: 'Imperial Workshop Quiz', text: shareText, url: window.location.href }).catch(function(){});
      else if (navigator.clipboard) navigator.clipboard.writeText(shareText + ' ' + window.location.href).then(function () { if (noteEl) noteEl.textContent = 'Copied your result and link to clipboard.'; });
      else if (noteEl) noteEl.textContent = shareText + ' ' + window.location.href;
      return;
    }
    var viewBtn = event.target.closest('.builder-view-btn');
    if (viewBtn) {
      var view = viewBtn.getAttribute('data-view');
      if (view === 'front') setBuilderView(0, 0);
      if (view === 'angle') setBuilderView(-14, -28);
      if (view === 'side') setBuilderView(0, 90);
      if (view === 'rear') setBuilderView(0, 180);
      if (view === 'reset') setBuilderView(-14, -28);
      return;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    selectQuizPromptSet();
    renderQuiz();
    initBuilderSystem();
    initBuilderDrag();
    initBuilderSearch();
    initBuilderCart();
    syncBuilderConfigFields();
  });
})();


(function(){
  function initProductGallery(){
    var slides = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-index]'));
    if(!slides.length || !thumbs.length) return;
    var active = 0;

    function show(idx){
      active = (idx + slides.length) % slides.length;
      for(var i=0;i<slides.length;i++){
        slides[i].classList.toggle('is-active', i === active);
      }
      for(var j=0;j<thumbs.length;j++){
        thumbs[j].classList.toggle('is-active', j === active);
      }
    }

    document.addEventListener('click', function(e){
      var thumb = e.target.closest('[data-gallery-index]');
      if(thumb){
        show(parseInt(thumb.getAttribute('data-gallery-index'), 10) || 0);
        return;
      }
      var nav = e.target.closest('[data-gallery-nav]');
      if(nav){
        var dir = nav.getAttribute('data-gallery-nav');
        show(active + (dir === 'next' ? 1 : -1));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initProductGallery);
})();


(function(){
  function initBladeSizeSelector(){
    var options = Array.prototype.slice.call(document.querySelectorAll('.blade-size-option'));
    if(!options.length) return;
    document.addEventListener('change', function(e){
      var input = e.target.closest('.blade-size-option input');
      if(!input) return;
      for(var i=0;i<options.length;i++){
        options[i].classList.remove('is-active');
      }
      var label = input.closest('.blade-size-option');
      if(label) label.classList.add('is-active');
    });
  }
  document.addEventListener('DOMContentLoaded', initBladeSizeSelector);
})();


(function(){
  function initActualMobileHeader(){
    var drawer = document.getElementById('mobileNavDrawer');
    var openBtn = document.querySelector('.mobile-menu-btn');
    var closeBtn = document.querySelector('.mobile-close-btn');
    var backdrop = document.querySelector('.mobile-nav-backdrop');
    if(!drawer || !openBtn) return;

    function openDrawer(){
      drawer.hidden = false;
      openBtn.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer(){
      drawer.hidden = true;
      openBtn.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', function(){
      if(drawer.hidden){ openDrawer(); } else { closeDrawer(); }
    });

    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if(backdrop) backdrop.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function(e){
      var link = e.target.closest('a');
      if(link) closeDrawer();
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && !drawer.hidden){ closeDrawer(); }
    });
  }

  document.addEventListener('DOMContentLoaded', initActualMobileHeader);
})();




(function(){
  function updateMobileMenuScrollState(){
    var panel = document.querySelector('.mobile-nav-panel');
    if(!panel) return;
    if(panel.scrollTop > 18){
      panel.classList.add('is-scrolled');
    } else {
      panel.classList.remove('is-scrolled');
    }
  }

  function initCategoryAccordion(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.mobile-drawer-accordion');
      if(!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var submenu = btn.nextElementSibling;
      if(!submenu || !submenu.classList.contains('mobile-drawer-submenu')) return;

      var willOpen = submenu.hasAttribute('hidden');
      if(willOpen){
        submenu.removeAttribute('hidden');
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        submenu.setAttribute('hidden', 'hidden');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    var panel = document.querySelector('.mobile-nav-panel');
    if(panel){
      panel.addEventListener('scroll', updateMobileMenuScrollState, { passive: true });
    }
  }

  document.addEventListener('DOMContentLoaded', initCategoryAccordion);
})();


(function(){
  document.addEventListener('click', function(e){
    var summary = e.target.closest('.mobile-shop-summary');
    if(!summary) return;
    e.stopPropagation();
  }, true);
})();


(function(){
  function initProductGallerySwipe(){
    var main = document.getElementById('ProductGalleryMain');
    if(!main) return;
    var slides = Array.prototype.slice.call(main.querySelectorAll('.gallery-slide'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
    if(!slides.length) return;
    main.classList.add('is-swipe-enabled');

    function activeIndex(){
      for(var i=0;i<slides.length;i++){
        if(slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    function showIndex(idx){
      if(idx < 0) idx = slides.length - 1;
      if(idx >= slides.length) idx = 0;
      for(var i=0;i<slides.length;i++){
        slides[i].classList.toggle('is-active', i===idx);
      }
      for(var j=0;j<thumbs.length;j++){
        thumbs[j].classList.toggle('is-active', j===idx);
      }
    }

    var startX = 0, startY = 0, dragging = false;
    main.addEventListener('touchstart', function(e){
      if(!e.touches || !e.touches.length) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, {passive:true});

    main.addEventListener('touchend', function(e){
      if(!dragging || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      dragging = false;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
        var idx = activeIndex();
        showIndex(dx < 0 ? idx + 1 : idx - 1);
      }
    }, {passive:true});
  }

  document.addEventListener('DOMContentLoaded', initProductGallerySwipe);
})();

document.querySelectorAll('.swatch-circle').forEach(swatch => {
  const colorMap = {
    'black': '#1a1a1a',
    'silver': '#A8A9AD',
    'gold': '#C9A84C',
  };
  const handle = swatch.getAttribute('aria-label').toLowerCase().replace(/\s+/g, '-');
  if (colorMap[handle]) swatch.style.backgroundColor = colorMap[handle];
});
